import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AuthImage from "@/components/AuthImage";
import Logo from "@/components/Logo";
import { LogOut, LayoutDashboard, UserCircle } from "lucide-react";

export default function MemberHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 bg-[#FCFCFA]/85 backdrop-blur-xl border-b border-[#E3DED2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/area" data-testid="header-logo" className="flex items-center">
          <Logo variant="dark" className="h-11 sm:h-14" />
        </Link>
        <nav className="flex items-center gap-1 sm:gap-3">
          {user?.role !== "admin" && (
            <>
              <Link to="/area" data-testid="nav-agenda-link" className="hidden sm:inline text-sm text-[#48020C] hover:text-[#6E5F58] transition-colors px-3 py-2">Agenda</Link>
              <Link to="/area/os-meus-planos" data-testid="nav-myplans-link" className="hidden sm:inline text-sm text-[#48020C] hover:text-[#6E5F58] transition-colors px-3 py-2">Os meus planos</Link>
              <Link to="/area/suporte" data-testid="nav-support-link" className="hidden sm:inline text-sm text-[#48020C] hover:text-[#6E5F58] transition-colors px-3 py-2">Falar com o admin</Link>
              <Link to="/area/perfil" data-testid="nav-profile-text-link" className="hidden sm:inline text-sm text-[#48020C] hover:text-[#6E5F58] transition-colors px-3 py-2">O meu perfil</Link>
            </>
          )}
          {user?.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin-link" className="flex items-center gap-2 text-sm text-[#48020C] hover:text-[#6E5F58] transition-colors px-3 py-2">
              <LayoutDashboard className="w-4 h-4" /> <span className="hidden sm:inline">Admin</span>
            </Link>
          )}
          <Link to="/area/perfil" data-testid="nav-profile-link" className="flex items-center gap-2">
            <AuthImage path={user?.photo_path} fallbackName={user?.name} className="w-10 h-10 rounded-full object-cover border border-[#48020C]" />
          </Link>
          <button data-testid="logout-btn" onClick={handleLogout} className="flex items-center gap-2 text-sm text-[#6E6359] hover:text-[#48020C] transition-colors px-2 py-2">
            <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Sair</span>
          </button>
        </nav>
      </div>
    </header>
  );
}
